export { CnMessage } from '@cainiaofe/cn-ui';
